export const reduceFilters = filtersApplied => {
  const filter = filtersApplied ?? []
  const valorInicial = {
    keyword: null,
    area: null,
    subarea: null,
    provincia: null,
    localidad: null,
    nivelLaboral: null,
    tipoTrabajo: null,
    modalidadTrabajo: null,
    tipoContratacion: null,
    discapacidad: null,
  }

  return filter.reduce((acc, value) => {
    if (value.id === 'query') {
      return { ...acc, keyword: value.value }
    }
    if (value.type === 'area') {
      return { ...acc, area: value.id }
    }
    if (value.type === 'subarea') {
      return { ...acc, subarea: value.id }
    }
    if (value.type === 'provincia') {
      return { ...acc, provincia: value.id }
    }
    if (value.type === 'localidad') {
      return { ...acc, localidad: value.id }
    }
    if (value.type === 'nivel_laboral') {
      return { ...acc, nivelLaboral: value.id }
    }
    if (value.type === 'tipo_trabajo') {
      return { ...acc, tipoTrabajo: value.id }
    }
    if (value.type === 'modalidad_trabajo') {
      return { ...acc, modalidadTrabajo: value.id }
    }
    if (value.type === 'apto_discapacitado') {
      return { ...acc, discapacidad: true }
    }
    // TODO: ver si es correcto cuando se implemente la faceta en el buscador
    if (value.type === 'tipo_contratacion') {
      return { ...acc, tipoContratacion: value.id }
    }
    return acc
  }, valorInicial)
}
